var _excluded = ["children", "disabled", "icon", "multiple", "selected"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'classnames';
import IconCheckmark from '../../icons/icon_checkmark';
import IconX from '../../icons/icon_x';
import isVeneerIcon from '../../utils/is_veneer_icon';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Option = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      disabled = false,
      icon,
      multiple = false,
      selected = false
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var optionIcon = multiple && selected ? ___EmotionJSX(React.Fragment, null, ___EmotionJSX(IconCheckmark, {
    className: "vn-option__iconbutton icon_checkmark"
  }), ___EmotionJSX(IconX, {
    className: "vn-option__iconbutton icon_x"
  })) : null;
  return ___EmotionJSX("li", _extends({
    "aria-disabled": disabled,
    "aria-selected": selected,
    className: classNames('vn-option', {
      disabled,
      multiple,
      icon,
      'vn-icon': isVeneerIcon(icon)
    }),
    ref: ref,
    role: "option"
  }, props), optionIcon, /*#__PURE__*/React.isValidElement(icon) && /*#__PURE__*/React.cloneElement(icon, {
    className: 'vn-option__icon',
    disabled
  }), ___EmotionJSX("div", {
    className: "vn-option__label"
  }, ___EmotionJSX("span", null, children)));
});
Option.displayName = 'Option';
export default Option;